import React from 'react';

interface ExtraDescriptionProps {
  style?: React.CSSProperties;
  content: string | JSX.Element | JSX.Element[];
}

export const ExtraDescription: React.FC<React.PropsWithChildren<ExtraDescriptionProps>> = ({ content, style }) => {
  return <div style={style}>{content}</div>;
};
